import React from 'react';
import { Sparkles, ExternalLink } from 'lucide-react';
interface MatchContextProps {
  visible: boolean;
}
export function MatchContext({
  visible
}: MatchContextProps) {
  if (!visible) return null;
  return <section className="px-6 md:px-12 max-w-6xl mx-auto mt-6 mb-8 relative z-20" data-id="element-162">
      <div className="bg-brand-forest/10 border border-brand-forest/20 rounded-2xl px-6 py-5" data-id="element-163">
        <div className="flex items-start gap-3" data-id="element-164">
          <div className="w-8 h-8 rounded-full bg-brand-forest/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-165">
            <Sparkles size={16} className="text-brand-forest" data-id="element-166" />
          </div>
          <div data-id="element-167">
            <p className="text-sm font-medium text-brand-dark mb-1" data-id="element-168">
              Why you were matched
            </p>
            <p className="text-sm text-brand-muted leading-relaxed" data-id="element-169">
              Krystle and the Roth Real Estate Group specialize in the Inland
              Empire — Redlands, Yucaipa, Highland, Loma Linda, Moreno Valley,
              and beyond — with{' '}
              <span className="font-mono text-brand-dark" data-id="element-170">21 years</span> of
              experience,{' '}
              <span className="font-mono text-brand-dark" data-id="element-171">514</span> lifetime
              sales, and{' '}
              <span className="font-mono text-brand-dark" data-id="element-172">52</span> closings
              in the last 12 months at a{' '}
              <span className="font-mono text-brand-dark" data-id="element-173">$634K</span>{' '}
              average price point.{' '}
              <a href="https://www.zillow.com/profile/RothGetsResults" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 text-brand-forest hover:underline" data-id="element-174">
                Source: Zillow <ExternalLink size={10} data-id="element-175" />
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>;
}